import { Helmet } from "react-helmet-async";

const SITE_NAME = "Graceful Garden Coaching";
const DEFAULT_IMAGE = "/hero-garden.jpg";

/** Reusable SEO head — sets title, description, canonical, OG, Twitter Card, and JSON-LD. */
export default function SEO({
  title,
  description,
  canonical,
  image,
  type = "website",
  publishedTime,
  modifiedTime,
  author,
  jsonLd,
  keywords,
  noindex = false,
}) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : SITE_NAME;
  const shortTitle = title || SITE_NAME;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const resolvedImage = image
    ? (image.startsWith("http") ? image : `${origin}${image}`)
    : `${origin}${DEFAULT_IMAGE}`;
  const canonicalUrl = canonical || (typeof window !== "undefined" ? window.location.href.split("?")[0] : "");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={shortTitle} />
      {description && <meta property="og:description" content={description} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={resolvedImage} />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {author && <meta property="article:author" content={author} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={shortTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={resolvedImage} />

      {/* jsonLd may be a single object or an array of schemas — emit one <script> each. */}
      {jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
